import en from './en';
import ko from './ko';

export default { en, ko };
